import { LOCALES } from '../locales';

export default {
	[LOCALES.RUSSIAN]: {
		'Hello': 'Привет, {name}!',
        'TÜM TERMİNALLER': 'ВСЕ ТЕРМИНАЛЫ',
        'BÖLÜM BAZINDA': 'ПО СЕКЦИЯМ',
        'FİLTRE BAZINDA': 'ПО ФИЛЬТРУ',
        'Bildiren': 'Сообщает',
        'Renk': 'Цвет',
        'Sicil': 'Учетный номер',
        'Parça': 'Деталь',
        'Hata': 'Ошибка',
        'Saat': 'Время',
        'Hata Türü': 'Тип ошибки',
        'Hata Sor': 'Ответственный за ошибку',
        'Alt Sorumlu': 'Подответственный',
        'Kaydet': 'Сохранить',
        'İşlem': 'Операция',
        'MONTAJ NO': 'Номер монтажа',
        'BODY NO': 'Номер кузова',
        'ARA': 'Поиск',
        'Teknik Destek': 'Техническая поддержка',
        'ARAÇ LİSTESİ': 'Список автомобилей',
        'MANUEL HATA': 'Ручная ошибка',
        'ÇOKLU HATA': 'Множественная ошибка',
        'HATA LİSTESİ': 'Список ошибок',
        'HATA KOPYA': 'Копировать ошибку',
        'ÇIKIŞ': 'Выход',
        'Toplam satır': 'Всего строк',
        'HATA GİRİŞ EKRANI': 'Экран ввода ошибки',
        'HIZLI KAYDET': 'Быстрое сохранение',
        'KAYDET VE GEÇ': 'Сохранить и продолжить',
        'HATA KAYIT': 'Запись ошибки',
        'TERMİNAL İLK RESMİ': 'Первоначальное изображение терминала',
        'SIK GELEN HATA': 'Часто встречающаяся ошибка',
        'MANİFEST': 'Манифест',
        'MODEL İLK RESMİ': 'Первоначальное изображение модели',
        'GERİ': 'Назад',
        'TEMİZLE': 'Очистить',
        'BÜYÜK FONT': 'Крупный шрифт',
        'Harigami': 'Харигами',
        'Tarih': 'Дата',
        'Terminal Listesi': 'Список терминалов',
        'Sicil No': 'Учетный номер',
        'Şifre': 'Пароль',
        'Giriş Yap': 'Войти',
        'Kapat': 'Закрыть',
        'Montaj No': 'Номер монтажа',
        'Vardiya': 'Смена',
        'Girdiğiniz bilgiler hatalıdır!': 'Вы ввели неверные данные!',
        'Giriş yapılıyor...': 'Вход в систему...',
        'Açıklama': 'Описание',
        'Yapılan İşlem': 'Выполнен',
	}
}